import { useRouter } from 'next/router';
import { useSettings } from 'src/@core/hooks/useSettings';
import { ServiceLocation } from 'src/services/serviceLocationsAxios';
import buildFilterString from '../../helpers/buildFilterString';
import CountWidget from '../counterWidget';

const TotalDiscrepancies = ({ dashboardDateStrings = [[''], ['']], orderByValue = '' }) => {
  const router = useRouter();
  const settings = useSettings();

  const and = orderByValue.trim() == '' ? '' : 'and ';

  return (
    <CountWidget
      onSelect={() => {
        if (!settings.settings.unlockDashboardLayout) {
          router.push(
            `/uiflow/consignment?filter=${buildFilterString(
              orderByValue,
              dashboardDateStrings
            )}&extrafilter=hasDiscrepancies eq true`
          );
        }
      }}
      name="discrepancies"
      serviceLocation={ServiceLocation.salesorder}
      filter={`${buildFilterString(orderByValue, dashboardDateStrings)} ` + and + `hasDiscrepancies eq true`}
      endpoint="salesorder"
      title="Discrepancies"
      disableTooltip={true}
      sx={{
        height: '100%',
        padding: '17.5px',
        '& .countWidget__contentContainer': {
          justifyContent: 'space-between',
          container: 'test / inline-size !important'
        },
        '& .countWidget__title': { textAlign: 'left', fontSize: 'clamp(1rem, 10cqw, 1.571rem)', fontWeight: '600' },
        '& .countWidget__count': {
          fontSize: 'clamp(1rem, 30cqw, 3.714rem) !important',

          fontWeight: '500'
        }
      }}
    />
  );
};

export default TotalDiscrepancies;
